import React, { useState } from 'react';
import { FaGithub } from 'react-icons/fa';
import './Portfolio.css';
import useAutoTranslate from '../../hooks/useAutoTranslate';
import fr from './langue/fr.json';
import en from './langue/en.json';

const projects = [
    {
    id: 1,
    titleKey: 'projet_1_title',
    subtitleKey: 'projet_1_subtitle',
    descriptionKey: 'projet_1_description',
    img: 'assets/img/projet/portefolio-renew.jpg',
    techs: ['react', 'php','css'],
  },
  {
    id: 2,
    titleKey: 'projet_2_title',
    subtitleKey: 'projet_2_subtitle',
    descriptionKey: 'projet_2_description',
    img: 'assets/img/projet/automatisation.jpg',
    techs: ['python', 'csv', 'cisco', 'meraki', 'git'],
  },
  {
    id: 3,
    titleKey: 'projet_3_title',
    subtitleKey: 'projet_3_subtitle',
    descriptionKey: 'projet_3_description',
    img: 'assets/img/projet/portefolio.png',
    techs: ['html', 'css', 'bootstap', 'git'],
    github: 'https://github.com/Baptistelemattre/portfolio',
  },
  {
    id: 4,
    titleKey: 'projet_4_title',
    subtitleKey: 'projet_4_subtitle',
    descriptionKey: 'projet_4_description',
    img: 'assets/img/projet/marathon.png',
    techs: ['html', 'css', 'php', 'git'],
    github: 'https://github.com/Baptistelemattre/Marathon',
  },
  {
    id: 5,
    titleKey: 'projet_5_title',
    subtitleKey: 'projet_5_subtitle',
    descriptionKey: 'projet_5_description',
    img: 'assets/img/projet/lab.png',
    techs: ['java', 'git'],
    github: 'https://github.com/Baptistelemattre/labyrinthe',
  },
  {
    id: 6,
    titleKey: 'projet_6_title',
    subtitleKey: 'projet_6_subtitle',
    descriptionKey: 'projet_6_description',
    img: 'assets/img/projet/iut.png',
    techs: ['html', 'css', 'bootstap'],
    github: 'https://github.com/Baptistelemattre/projet_site_web_iut/tree/main/projet_tutor%C3%A9',
  },
  {
    id: 7,
    titleKey: 'projet_7_title',
    subtitleKey: 'projet_7_subtitle',
    descriptionKey: 'projet_7_description',
    img: 'assets/img/projet/arma.png',
    techs: ['cpp', 'ps'],
  },
];

function ProjectCard({ project, t, onClick }) {
  return (
    <div className="portfolio__item" onClick={() => onClick(project)}>
      <div className="portfolio__img-wrap">
        <img src={project.img} alt={t(project.titleKey)} />
        <div className="portfolio__overlay">
          <span>+</span>
        </div>
      </div>
      <div className="portfolio__caption">
        <h3>{t(project.titleKey)}</h3>
        <p>{t(project.subtitleKey)}</p>
      </div>
    </div>
  );
}

function ProjectModal({ project, t, onClose }) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className={`modal-box modal-box--color-${((project.id - 1) % 3) + 1}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="modal-close" onClick={onClose}>✕</button>
        <h2>{t(project.titleKey)}</h2>
        <p className="modal-subtitle">{t(project.subtitleKey)}</p>
        <img src={project.img} alt={t(project.titleKey)} className="modal-img" />
        <p className="modal-desc">{t(project.descriptionKey)}</p>
        <div className="modal-techs">
          <h4>{t('technologies_utilisees')}</h4>
          <div className="modal-techs__icons">
            {project.techs.map((tech) => (
              <img key={tech} src={`assets/img/techno/${tech}.png`} alt={tech} />
            ))}
          </div>
        </div>
        {project.github && (
          <a href={project.github} target="_blank" rel="noreferrer" className="modal-github">
            <FaGithub size={20} />
            {t('voir_sur_github')}
          </a>
        )}
      </div>
    </div>
  );
}

function Portfolio() {
  const [selectedProject, setSelectedProject] = useState(null);
  const t = useAutoTranslate({ fr, en });

  return (
    <section className="portfolio bg-black-section" id="portfolio">
      <div className="section-container">
        <div className="text-center">
          <h2 className="section-heading">{t('mes_projets')}</h2>
        </div>

        <div className="portfolio__grid">
          {projects.map((project) => (
            <ProjectCard
              key={project.id}
              project={project}
              t={t}
              onClick={setSelectedProject}
            />
          ))}
        </div>
      </div>

      {selectedProject && (
        <ProjectModal
          project={selectedProject}
          t={t}
          onClose={() => setSelectedProject(null)}
        />
      )}
    </section>
  );
}

export default Portfolio;